import { Box } from "@mui/material";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";

const ArticleAltmetric = ({ doi }: { doi: string }) => (
  <Box>
    <StyledDivider label={"Altmetric"} />
    <Box sx={{
      mt: 2
    }}>
      <Box
        data-badge-details="right"
        data-badge-type="medium-donut"
        data-doi={doi}
        data-condensed="true"
      />
    </Box>
  </Box>
);

export default ArticleAltmetric;
